import { isSystemDark } from './isSystemDark';
import { ThemeMode } from '../schema/ThemeMode';

export const computeIsDarkThemeFromThemeMode = (themeMode: ThemeMode): boolean =>
    themeMode === ThemeMode.Dark || (themeMode === ThemeMode.System && isSystemDark());
